import React, { useState, useEffect } from "react";
import { OverviewSVG, OverviewSVGSelected } from "../images-svg/OverviewSvg";
import { MapSVG, MapSVGSelected } from "../images-svg/MapSvg";
import { ReportSVG, ReportSVGSelected } from "../images-svg/ReportSvg";
import {
  ManageUserSVG,
  ManageUserSVGSelected,
} from "../images-svg/ManageUserSvg";
import { ProfileSVG, ProfileSVGSelected } from "../images-svg/ProfileSvg";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { LogoutAPI } from "../../api/auth/Authentication";

interface MenuListType {
  id: number;
  label: string;
  icon: any;
  iconselected: any;
  path: string;
  isselected: boolean;
}
export interface UserInfoType {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  imageId: string;
  role: string;
}

function NavigationBar() {
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState<UserInfoType>();
  let refreshToken = localStorage.getItem("refresh_token");
  let location = useLocation();

  const [menuList, setMenuList] = useState<MenuListType[]>([
    {
      id: 1,
      label: "ภาพรวม",
      icon: OverviewSVG,
      iconselected: OverviewSVGSelected,
      path: "/dashboard",
      isselected: false,
    },
    {
      id: 2,
      label: "แผนที่",
      icon: MapSVG,
      iconselected: MapSVGSelected,
      path: "/map",
      isselected: false,
    },
    {
      id: 3,
      label: "รายงาน",
      icon: ReportSVG,
      iconselected: ReportSVGSelected,
      path: "/report",
      isselected: false,
    },
    {
      id: 4,
      label: "จัดการผู้ใช้งาน",
      icon: ManageUserSVG,
      iconselected: ManageUserSVGSelected,
      path: "/mange-user",
      isselected: false,
    },
    {
      id: 5,
      label: "โปรไฟล์",
      icon: ProfileSVG,
      iconselected: ProfileSVGSelected,
      path: "/profile",
      isselected: false,
    },
  ]);

  const handleNavigation = (path: string) => {
    if (path && path.trim() !== "") {
      if (path === "/mange-user") {
        let manageURL = `${process.env.REACT_APP_API_VALLARIS}/management/authentication?refresh_token=${refreshToken}&callback_uri=https://vallaris.dragonfly.gistda.or.th/management/group`;
        if (typeof manageURL === "string")
          window.open(manageURL, "_blank", "noreferrer");
      } else {
        navigate(`${path}`);
      }
    }
  };

  const userLogout = async () => {
    try {
      await LogoutAPI();
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
      localStorage.removeItem("token_type");
      localStorage.removeItem("expired_at");
      localStorage.removeItem("refresh_token");
      navigate("/login");
    } catch (error: any) {
      console.log(error);
      if (error?.response.status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("access_token");
        localStorage.removeItem("token_type");
        localStorage.removeItem("expired_at");
        localStorage.removeItem("refresh_token");
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    let currentUrl = location.pathname;
    let firstPath = currentUrl.split("/")[1];

    let newArray = [];

    newArray = menuList?.map((menu) => {
      if (`/${menu.path.split("/")[1]}` === `/${firstPath}`) {
        menu.isselected = true;
      } else {
        menu.isselected = false;
      }
      return menu;
    });
    setMenuList(newArray);
  }, [location]);

  useEffect(() => {
    let user = localStorage.getItem("user");
    if (user) {
      setUserInfo(JSON.parse(user));
    }
  }, []);

  useEffect(() => {
    if (userInfo) {
      if (userInfo.role === "admin") {
        setMenuList([
          {
            id: 1,
            label: "ภาพรวม",
            icon: OverviewSVG,
            iconselected: OverviewSVGSelected,
            path: "/dashboard",
            isselected: false,
          },
          {
            id: 2,
            label: "แผนที่",
            icon: MapSVG,
            iconselected: MapSVGSelected,
            path: "/map",
            isselected: false,
          },
          {
            id: 3,
            label: "รายงาน",
            icon: ReportSVG,
            iconselected: ReportSVGSelected,
            path: "/report",
            isselected: false,
          },
          {
            id: 4,
            label: "จัดการผู้ใช้งาน",
            icon: ManageUserSVG,
            iconselected: ManageUserSVGSelected,
            path: "/mange-user",
            isselected: false,
          },
          {
            id: 5,
            label: "โปรไฟล์",
            icon: ProfileSVG,
            iconselected: ProfileSVGSelected,
            path: "/profile",
            isselected: false,
          },
        ]);
      } else {
        setMenuList([
          {
            id: 1,
            label: "ภาพรวม",
            icon: OverviewSVG,
            iconselected: OverviewSVGSelected,
            path: "/dashboard",
            isselected: false,
          },
          {
            id: 2,
            label: "แผนที่",
            icon: MapSVG,
            iconselected: MapSVGSelected,
            path: "/map",
            isselected: false,
          },
          {
            id: 3,
            label: "รายงาน",
            icon: ReportSVG,
            iconselected: ReportSVGSelected,
            path: "/report",
            isselected: false,
          },
          {
            id: 4,
            label: "โปรไฟล์",
            icon: ProfileSVG,
            iconselected: ProfileSVGSelected,
            path: "/profile",
            isselected: false,
          },
        ]);
      }
    }
  }, [userInfo]);

  return (
    <div className="w-full h-screen sticky top-0 left-0 bg-background-paper shadow-[0px_8px_24px_0px rgba(209, 209, 209, 0.14)] px-4 py-8 flex flex-col item-center justify-between flex-shrink-0">
      <div className="flex flex-col gap-8">
        <Link to={`/dashboard`} className="self-center">
          <img
            className="mx-auto"
            src="/images/logo-bar.svg"
            alt="logo-bar"
            height={40}
            width={109}
          />
        </Link>
        <div className="w-full flex flex-col self-stretch item-center gap-1">
          {menuList.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNavigation(item.path)}
              className={`${
                location.pathname.includes(item.path)
                  ? "bg-primary-main bg-opacity-20 text-primary-main"
                  : "bg-background-paper text-text-primary"
              }   button-navbar rounded-xl flex gap-2 items-center duration-500`}
            >
              <div className="p-1">
                {location.pathname.includes(item.path) ? (
                  <item.iconselected />
                ) : (
                  <item.icon />
                )}
              </div>
              <p> {item.label}</p>
            </button>
          ))}
        </div>
      </div>
      <button
        onClick={userLogout}
        className="bg-background-paper text-text-primary button-navbar flex gap-2 items-center"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 16V18C16 20.2091 14.2091 22 12 22H7C4.79086 22 3 20.2091 3 18V6C3 3.79086 4.79086 2 7 2H12C14.2091 2 16 3.79086 16 6V8"
            stroke="#F05B50"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M19 15L21.2929 12.7071C21.6834 12.3166 21.6834 11.6834 21.2929 11.2929L19 9"
            stroke="#F05B50"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M21 12L9 12"
            stroke="#F05B50"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>

        <p className="text-error-main">ออกจากระบบ</p>
      </button>
    </div>
  );
}

export default NavigationBar;
